import i18n from 'i18next';

/**
 * txLabel — localize a DB taxonomy label (event category / activity category /
 * venue type) by its SLUG.
 *
 * CON-1606. Category names live in Neon and were never part of the i18n
 * bundle, so they rendered English in every locale — Patrick found "Sports",
 * "Live Music", "Water activities", "Cultural", "Landmarks" still English in
 * an otherwise Vietnamese app.
 *
 * `i18n-sync-taxonomy.mjs` registers every slug as `taxonomy.<slug>` in
 * en.json, so these are now ordinary keys translated by the normal pipeline.
 * Re-run that script whenever a category is added and the new slug flows out
 * to all 14 locales like any other string.
 *
 * Deliberately falls back to the English label the caller already had, so a
 * slug that has not been synced yet degrades to today's behaviour rather than
 * rendering a raw `act_surfing` at the user.
 *
 * Module-scope safe: uses the i18next singleton, not the hook, because most
 * call sites are static config maps and formatters outside React.
 */
export function txLabel(slug, fallback) {
  if (!slug) return fallback || '';
  return i18n.t(`taxonomy.${slug}`, fallback ?? slug);
}

/** Localize a {slug: {label, ...}} config map, preserving every other field. */
export function txConfig(config) {
  const out = {};
  for (const [slug, cfg] of Object.entries(config || {})) {
    out[slug] = { ...cfg, label: txLabel(slug, cfg?.label) };
  }
  return out;
}

export default txLabel;
